module.exports = __webpack_public_path__ + "e3e78646f061ebef69e44804de5acc3d.jpg";